import { companySchema } from "@/schema/assessment-results/Company";
import { mainCategoryResultSchema } from "@/schema/assessment-results/MainCategoryResult";
import { sdgGoalResultSchema } from "@/schema/assessment-results/SdgGoalResult";
import { z } from "zod";

export const assessmentResultSchema = z.object({
  id: z.number(),
  company: companySchema,
  result: z.object({
    score: z.number().nullable(),
    sdg_score: z.number().nullable(),
    main_category_results: z.array(mainCategoryResultSchema),
    sdg_goal_results: z.array(sdgGoalResultSchema),
  }),
  updated_at: z.coerce.date(),
});

export type AssessmentResult = z.infer<typeof assessmentResultSchema>;
